import { render } from "./ProductSearch.vue?vue&type=template&id=2fadc58f&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=2fadc58f&scoped=true&lang=css"
import "./ProductSearch.vue?vue&type=style&index=1&id=2fadc58f&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fadc58f"]])

export default __exports__